var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.315h4.821c.018 1.795 1.543 3.24 3.434 3.24 1.891 0 3.416-1.445 3.434-3.24h2.466v1.829l-1.037.005v2.288l5.759-.046v-2.288l-1.037.006v-3.02c0-1.195-1.019-2.171-2.282-2.171h-4.741V7.443h-1.714V5.796m-1.702 0v1.647H8.687v1.486H3",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.374 3.512A1.47 1.47 0 0 0 11.25 3c-.455 0-.86.2-1.125.512M12.67 5.98h4.106c.213 0 .414-.11.518-.29l.397-.68a.546.546 0 0 0 0-.546l-.397-.68a.59.59 0 0 0-.518-.29H12.67a.703.703 0 0 0-.44.151l-.732.592a.624.624 0 0 0 0 .988l.732.592a.669.669 0 0 0 .44.163Z",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84 3.495H5.735a.598.598 0 0 0-.519.29l-.396.68a.545.545 0 0 0 0 .545l.396.68a.59.59 0 0 0 .519.29H9.84a.703.703 0 0 0 .44-.15l.731-.593a.624.624 0 0 0 0-.987l-.732-.593a.68.68 0 0 0-.44-.162Z",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.126 22.112H19.27a.51.51 0 0 0 .022 0c1.155-.05 1.906-1.248 1.39-2.29h0v-.002l-1.026-2.044a.5.5 0 0 0-.894 0l-1.024 2.043c-.527 1.04.23 2.243 1.39 2.293Z",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.96c22cdd.svg";
export { ForwardRef as ReactComponent };